<div class="container-fluid">
    <div class="row  m-3">
       <mat-card class="col-12">
        <mat-card-title class="text-center">
            {{ env.header_home1 }}
        </mat-card-title>
        <mat-card-content>
            <p class="mt-3 text-center" [innerHTML]="env.header_home2">
            </p>
            <p class="mt-3 text-center" [innerHTML]="env.header_home3">
            </p>
        </mat-card-content>
    </mat-card> 
    </div>
    

    <ng-container *ngFor="let group of alertGroups">
        <div class="row m-3">
                <mat-card class="col-12">

                    <div class="d-flex align-items-center">
                        <mat-icon class="material-icons-outlined mr-2">notification_important</mat-icon> <h2> {{group.groupDescription}}</h2>
                    </div>
                    
                    
                    <div  *ngFor="let alert of getAlerts(group.groupId)" class="alert alert-{{alert.alertType}}">
                        {{alert.alertDescription}}
                    </div>
                </mat-card>
        </div>
    </ng-container>
    
</div>